<div class="main-wrapper d-flex align-items-center justify-content-center">
  <button mat-flat-button class="lang-btn" (click)="changeLanguage()">
    {{ 'general.language' | translate }}
  </button>
  <div class="card" style="margin-top: 40px; width: 767px;">
    <div class="logo-container">
      <img [src]="logoSrc" alt="">
    </div>
    <div class="card-content">

      <div *ngIf='loading' class="dataLoading">
        <mat-spinner class="m-auto" diameter="50"></mat-spinner>
      </div>

      <ng-container *ngIf="!loading">
        <div [innerHtml]="pageData | sanitizeHtml"></div>
      </ng-container>

    </div>
  </div>
</div>
